const GA_MEASUREMENT_ID = 'G-N6S3L5P7PH';
const ANALYTICS_CONSENT_KEY = 'stefficare-analytics-consent';
const HOMEPAGE_PATHS = new Set([
  '/',
  '/pflegeeinrichtungen',
  '/angehoerige',
  '/newsletter',
  '/waitlist',
  '/termin',
  '/impressum',
  '/nutzungsbedingungen',
  '/datenschutzhinweis',
]);

let analyticsReadyPromise = null;
let lastTrackedPageKey = null;

function canUseBrowserApis() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
}

function getAnalyticsArea(pathname) {
  return HOMEPAGE_PATHS.has(pathname) ? 'homepage' : 'platform';
}

function loadGoogleAnalyticsScript() {
  if (!canUseBrowserApis()) {
    return Promise.resolve();
  }

  const existingScript = document.querySelector(`script[data-ga-id="${GA_MEASUREMENT_ID}"]`);
  if (existingScript) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.dataset.gaId = GA_MEASUREMENT_ID;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Google Analytics konnte nicht geladen werden.'));
    document.head.appendChild(script);
  });
}

export function getAnalyticsConsent() {
  if (!canUseBrowserApis()) {
    return null;
  }

  const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
  return value === 'accepted' || value === 'declined' ? value : null;
}

export function setAnalyticsConsent(value) {
  if (!canUseBrowserApis()) {
    return;
  }

  window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
}

async function initializeAnalytics() {
  if (!canUseBrowserApis() || getAnalyticsConsent() !== 'accepted') {
    return;
  }

  if (analyticsReadyPromise) {
    await analyticsReadyPromise;
    return;
  }

  analyticsReadyPromise = loadGoogleAnalyticsScript().then(() => {
    ensureGtag();
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: false,
    });
  });

  await analyticsReadyPromise;
}

export async function trackAnalyticsPageView(pathname, search = '') {
  if (!canUseBrowserApis()) {
    return;
  }

  await initializeAnalytics();

  if (!window.gtag) {
    return;
  }

  const pageKey = `${pathname}${search}`;
  if (lastTrackedPageKey === pageKey) {
    return;
  }

  lastTrackedPageKey = pageKey;
  window.gtag('event', 'page_view', {
    app_area: getAnalyticsArea(pathname),
    page_location: window.location.href,
    page_path: pageKey,
    page_title: document.title,
  });
}

export async function trackAnalyticsEvent(name, parameters = {}) {
  if (!canUseBrowserApis()) {
    return;
  }

  await initializeAnalytics();

  if (window.gtag) {
    window.gtag('event', name, parameters);
  }
}
